import React, { useEffect, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import AuthenticationContext from '../../contexts/AuthenticationContext';
import { pendingUploadsWarning } from '../../utils/backgroundPhotoUploads';

function Logout() {
  const authStore = useContext(AuthenticationContext);
  const history = useHistory();
  // SW2-2458: photos still uploading exist only in this tab; logging out would
  // reload it and lose them. Checked once, on arrival.
  const [blocked] = React.useState(() => pendingUploadsWarning('signing out'));

  useEffect(() => {
    if (blocked) {
      history.goBack();

      return;
    }

    window.location.reload();
    authStore.logout();
    window.location.href = `${process.env.REACT_APP_LOGIN_URL}/login`;
  }, []);

  return blocked ? null : <Redirect push to='/login' />;
}

export default Logout;
